import { OnInit, OnDestroy, Component, Optional, Inject } from '@angular/core';
import {
    IContextService, DomainContext,
    PershingTranslationService, IAuthorizationService
} from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiContextUtils } from '@pershing/nxi-common';

declare let dojoApp: any;

@Component({
    selector: 'dojo-traded-valuations',
    templateUrl: './traded-valuations.component.html'
})
export class DojoTradeValuationsComponent implements OnInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    managedAccount: any;
    subs: Subscription;
    acctRef: any;
    appSettings: any;
    assetType: string = 'all';
    realTimeActive: boolean = false;
    isAdaTheme: boolean = false;
    isMobileTheme: boolean = false;
    asOfDate: string = '';
    title: string;
    isGroup: boolean = false;
    isEntitledForMod: boolean = false;
    restUrl: string = '';
    constructor(
        private contextService: IContextService,
        private translationService: PershingTranslationService,
        private nxiRestService: NxiRestService,
        private authService: IAuthorizationService,
        @Optional() @Inject('AppSettings') appSettings: any) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
        this.appSettings = appSettings;
        if (appSettings.themeType && appSettings.themeType === 'ada') {
            this.isAdaTheme = true;
            this.title = 'dojo-holdings-aggregate';
        }
        if (appSettings.deviceType && appSettings.deviceType === 'mobile') {
            this.isMobileTheme = true;
        }
    }

    ngOnInit() {
        this.restUrl = this.nxiRestService.serviceUrl;
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            this.initializeDojoWidget();
        });
        this.isEntitledForMod = this.authService.isEntitled('MOD_QUOTES_NEWS');
    }

    ngOnDestroy(): void {
        console.log('In DojoHoldingsAggregateComponent destroy method');
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyHoldingsAggregate();
        }
    }

    initializeDojoWidget(): void {
        this.nxiRestService.getBackEndDate().subscribe(
            (resp) => {
                if (resp && resp.date) {
                    this.asOfDate = resp.date;
                }
            }
        );
        this.nxiRestService.getAccountByReference(this.acctRef).subscribe(
            (resp) => {
                if (resp) {
                    this.isGroup = resp.group;
                    this.renderDojoWidget();
                }
            }
        );
    }

    backToHoldings(): void {
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail: {
                'gotoPage': '/nxi/portfolio/holdings'
            }
        }));
    }

    renderDojoWidget() {
        if (dojoApp) {
            this.restUrl = this.nxiRestService.serviceUrl;
            let require: any = window['require'];
            this.destroyDojoWidget();
            let self = this;
            require(['dojo/dom', 'dojo/dom-construct', 'nxi/widgets/holding/TradedValuation'], function (dom, domConstruct, TradedValuation) {
                if (dom.byId('tradedvaluations-parent')) {
                    let node = domConstruct.create('div', { id: 'tradedvaluations' });
                    domConstruct.place(node, dom.byId('tradedvaluations-parent'), 'first');
                    new TradedValuation({
                        storeUrl: self.restUrl + '/portfolio/' + self.acctRef + '/traded/valuation',
                        acctRef: self.acctRef,
                        isgroup: self.isGroup,
                        isModEntEnabled: self.isEntitledForMod
                    }, 'tradedvaluations').startup();
                }
            });
        }
    }

    destroyDojoWidget() {
        let dijit: any = window['dijit'];
        let tradedVal = dijit.byId('tradedvaluations');
        if (tradedVal) {
            tradedVal.destroyRecursive();
        }
    }
}
